module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-3200.35df55a2.svg";